import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const scrollPositions = new Map();

export default function useScrollRestoration() {
  const location = useLocation();
  const keyRef = useRef(location.pathname + location.search);

  useEffect(() => {
    const key = keyRef.current;
    const y = scrollPositions.get(key) || 0;
    window.scrollTo(0, y);

    return () => {
      scrollPositions.set(key, window.scrollY);
    };
  }, [location]);
}

